export default __webpack_public_path__ + "static/affiliate-program-Software-1@mob2x-82f44236681543dab249bdd69bf075d7.png";